var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoolean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 14,
    height: 10,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33398 10.0762C7.29883 10.0781 7.875 9.31641 7.875 8.00391C7.875 6.69922 7.29492 5.94531 6.33398 5.94531C5.37305 5.94531 4.79492 6.69727 4.79297 8.00391C4.79297 9.31445 5.36914 10.0762 6.33398 10.0762ZM6.33398 9.46484C5.83594 9.46484 5.52344 8.96484 5.52539 8.00391C5.52734 7.05078 5.83789 6.54883 6.33398 6.54883C6.83203 6.54883 7.14258 7.05078 7.14453 8.00391C7.14453 8.96484 6.83398 9.46484 6.33398 9.46484ZM10.1509 6H9.46143L8.46729 6.63867V7.30273L9.40283 6.70508H9.42627V10H10.1509V6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoolean);
export default __webpack_public_path__ + "97120/static/media/boolean.f77f53293e8cad1c4403fd76de2392f1.svg";
export { ForwardRef as ReactComponent };